import { BucketEditType } from './experiment.shared.model.js';
export function isBucketEdit(item, type) {
  if (!type) {
    return typeof item === 'object' && 'type' in item && item['type'] in BucketEditType;
  }
  return typeof item === 'object' && item['type'] === type;
}
export function isPriceEdit(item) {
  return isBucketEdit(item, BucketEditType.Price);
}
export function isTranslationEdit(item) {
  return isBucketEdit(item, BucketEditType.TranslationKey);
}
export function isImageEdit(item) {
  return isBucketEdit(item, BucketEditType.Image);
}
export function isBucketEditArray(item) {
  return Array.isArray(item) && item.every(item => isBucketEdit(item));
}
export function getBucket(assignment) {
  return assignment?.bucket;
}
/**
 * Get all bucket edits of a specific type from an assignment.
 */
export function getBucketEditsOfType(assignment, type) {
  if (typeof assignment === 'string') return [];
  const {
    data
  } = assignment;
  if (!data) return [];
  const {
    edits
  } = data;
  if (!isBucketEditArray(edits)) return [];
  return edits.filter(edit => edit.type === type);
}
function findEditOfType(assignment, id, type) {
  const edits = getBucketEditsOfType(assignment, type);
  return edits.find(edit => edit.id === id);
}
/**
 * Find a specific translation key edit in an assignment by translation key.
 */
export const findTranslationKeyEdit = (assignment, key) => findEditOfType(assignment, key, BucketEditType.TranslationKey);
/**
 * Find a specific replacement text edit in an assignment by id (purposefully vague to support more than translation keys).
 */
export const findReplacementTextEdit = (assignment, id) => findEditOfType(assignment, id, BucketEditType.Text);
/**
 * Find a specific price edit in an assignment by ProductKey.
 */
export const findPriceEdit = (assignment, key) => findEditOfType(assignment, key, BucketEditType.Price);
/**
 * Find a specific image edit in an assignment by URL.
 */
export const findImageEdit = (assignment, url) => findEditOfType(assignment, url, BucketEditType.Image);